import { createClient } from '@supabase/supabase-js'
import logger from './utils/logger'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  logger.error('Missing Supabase environment variables!');
  logger.error('Make sure you have a .env.local file in the frontend_react directory');
  logger.error('File should contain:');
  logger.error('REACT_APP_SUPABASE_URL=https://your-project.supabase.co');
  logger.error('REACT_APP_SUPABASE_ANON_KEY=your_anon_key_here');
}

// Only create client if we have the required values
let supabase = null;
if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      storage: localStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  });
} else {
  logger.error('Cannot create Supabase client - missing credentials');
}

export { supabase };